/* Hier kan je custom JS plaatsen zonder in theme.js te pielen */

var ProductPage = function(options) {
  if (!options.el) {
  	return;  
  }
  
  var selectPersonalisation = document.querySelector('[data-select="personaliseren"]');
  var productFormPersonalisation = document.querySelector('[data-product-form="personaliseren"]');
  
  var setVisibilityProductFormPersonalisation = function(value) {    
  	(value === 'Ja')
    	? productFormPersonalisation.classList.add('is-visible')
    	: productFormPersonalisation.classList.remove('is-visible');  
  };
  
  var handleChangeSelectPersonalisation = function(e) {
    setVisibilityProductFormPersonalisation(e.target.value);
  };
  
  var setEventListeners = function() {
    selectPersonalisation.addEventListener('change', handleChangeSelectPersonalisation);
  };
  
  var init = function() {
    setEventListeners();
    setVisibilityProductFormPersonalisation(selectPersonalisation.value);
  };
  
  init();
};

ProductPage({
  el: document.querySelector('[data-product]')
});